import {Component, Input, ViewEncapsulation} from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
@Component({
    selector: 'app-base-page-content',
    templateUrl: './base-page-content.component.html',
    styleUrls: ['./base-page-content.component.scss'],
    encapsulation: ViewEncapsulation.ShadowDom
})
export class BasePageContentComponent {
    @Input() innerHtmlContent!: string | DocumentFragment;
    safeHtmlContent!: SafeHtml;
    
    constructor(private sanitizer: DomSanitizer) {}
    
    ngOnInit(){
        if(typeof this.innerHtmlContent === 'string')
        if (this.innerHtmlContent) {
            this.safeHtmlContent = this.sanitizer.bypassSecurityTrustHtml(this.innerHtmlContent);
        }
    }
}
